import { render, staticRenderFns } from "./EntitiesShow.vue?vue&type=template&id=479be385&"
import script from "./EntitiesShow.vue?vue&type=script&lang=js&"
export * from "./EntitiesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports